<template>
  <div
    class="base-image-input"
    :style="{ backgroundImage: `url(${value})` }"
    @click="chooseImage"
  >
    <span
      v-if="!value"
      class="placeholder"
    >
      {{ placeholderText }}
    </span>
    <span v-else>
      <b-button
        class="white-remove-cross" variant="primary"
        @click.stop="deleteImage">
        <span aria-hidden="true">&times;</span>
      </b-button>
    </span>
    <input
      class="file-input"
      ref="fileInput"
      type="file"
      @input="onSelectFile"
    >
  </div>
</template>

<script>
import helpers from '@/mixins/helpers';
import Compressor from 'compressorjs';

export default {
  name: 'BaseImageInput',
  mixins: [helpers],
  props: {
    placeholderText: {
      type: String,
      default: 'Choose an Image',
    },
    imageIndexName: {
      type: String,
      default: 'Image1',
    },
    value: {
      type: String,
      default: null,
    },
    enabled: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
  },
  methods: {
    clearInputElement() {
      this.$refs.fileInput.value = null; // clear the file on the hidden input element!
    },
    deleteImage() {
      this.clearInputElement();
      this.$emit('input', { imageIndexName: this.imageIndexName, selectedImage64Str: null, imageFile: null });
    },
    chooseImage() {
      if (this.enabled) {
        this.$refs.fileInput.click();
      } else {
        this.showOkModal('Selection Order Not Permitted', 'Please upload photos in slot order.');
      }
    },
    onSelectFile() {
      // Below values must be in sync with that of the Community Assessor
      // until a way to share configs between the CAT and the PWA is implemented
      const allowedMimeTypeExtensions = ['image/png', 'image/jpeg', 'image/gif'];

      const input = this.$refs.fileInput;
      const selectedFiles = input.files;

      if (selectedFiles && selectedFiles[0]) {
        if (!allowedMimeTypeExtensions.some((ext) => ext === selectedFiles[0].type)) {
          this.showOkModal('Image or File Format Not Supported', 'Supported file formats include .jpg, .png, and .gif.');
        } else {
          this.processTheFile(selectedFiles[0]);
        }
      }
    },
    processTheFile(selectedFile) {
      const vm = this;
      // MaxPhotoSize is 1024 * 1024 * 10 = 10485760 bytes = 10 MB
      const maxPhotoSize = 10485760;

      // automatically compress the selected image
      // eslint-disable-next-line no-unused-vars
      const compressor = new Compressor(selectedFile, {
        quality: 0.7,

        // The compression process is asynchronous,
        // which means you have to access the `result` in the `success` hook function.
        success(result) {
          console.log(`Size after compression is ${result.size / 1024 / 1024} MB.`);
          if (result.size > maxPhotoSize) {
            vm.showOkModal('Image Size Exceeded',
              'You cannot upload images larger than 10MB. '
            + 'Please adjust your camera settings to capture smaller-sized images or preprocess the image'
            + ' with an image processing tool to reduce its size before uploading.');
            vm.clearInputElement();
          } else {
            const reader = new FileReader();
            reader.readAsDataURL(result);
            reader.onload = () => {
              vm.$emit('input', {
                imageIndexName: vm.imageIndexName,
                selectedImage64Str: reader.result,
                imageFile: new File([result], result.name, { type: result.type }),
              });
            };
            reader.onerror = (error) => {
              console.log(error);
            };
          }
        },
        error(err) {
          console.log(err.message);
        },
      });
    },
  },
};
</script>
